import omsUserList from "./OmsUserList";

export default omsUserList;
